import { render } from "./DesignerDetail.vue?vue&type=template&id=42323a99&scoped=true"
import script from "./DesignerDetail.vue?vue&type=script&lang=js"
export * from "./DesignerDetail.vue?vue&type=script&lang=js"

import "./DesignerDetail.vue?vue&type=style&index=0&id=42323a99&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42323a99"]])

export default __exports__